import { useEffect, useState } from "react";
import images from "../images/images";
import "../style.css";

function ProgressHeaderWithPopup({ currentStep, totalSteps = 4, title }) {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [backPressedOnce, setBackPressedOnce] = useState(false);

  const segments = Array.from({ length: totalSteps }, (_, i) => (
    <div
      key={i}
      className={`progress-segment ${i < currentStep ? "active" : ""}`}
    ></div>
  ));

  function handleBackClickACB(action) {
    if (action === "confirm") {
      setIsPopupOpen(false);
      window.history.back();
      return;
    }

    if (backPressedOnce) {
      setIsPopupOpen(false);
      window.history.back();
    } else {
      setBackPressedOnce(true);
      setIsPopupOpen(true);
    }
  }
  // Reset popup when navigating away
  useEffect(() => {
    const resetState = () => {
      setIsPopupOpen(false);
      setBackPressedOnce(false);
    };

    window.addEventListener("hashchange", resetState);
    window.addEventListener("popstate", resetState);

    return () => {
      window.removeEventListener("hashchange", resetState);
      window.removeEventListener("popstate", resetState);
    };
  }, []);

  return (
    <div className="progress-header-wrapper" >
      <div className="progress-header-container">
        <div className="progress-header-back-row">
          <img
            src={images["icon_back"]}
            className="progress-back-button"
            onClick={handleBackClickACB}
            aria-label="Back"
            alt="Back"
          />
          <div className="mapOverview-profile-text">{title}</div>
        </div>
        <div className="progress-bar">{segments}</div>
      </div>

      {isPopupOpen && (
        <div className="progress-popup-warning">
          <div className="popup-warning-header">
            <div className="popup-warning-title">
              ⚠️ <strong>Wait a minute!</strong>
            </div>
          </div>
          <div className="popup-warning-text">
            If you go back now you will lose the progress you have made.
          </div>
          <div className="popup-warning-buttons">
            <button
              onClick={() => handleBackClickACB()}
              className="popUp_btn"
            >
              Go Back
            </button>
            <button onClick={() => setIsPopupOpen(false)} className="popUp_btn">
              Stay
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export { ProgressHeaderWithPopup };
